export const handleOptionChange = <T>(
    selectOption: (option: T) => void,
    unselectOption: () => void
): ((value: T | undefined) => void) => {
    return (value: T | undefined) => {
        if (!!value) {
            selectOption(value);
        } else {
            unselectOption();
        }
    };
};
